import { isAdviser } from "commons/src/helpers/RoleHelpers";
import { HYDRATE_STATE } from "commons/src/reducers/indexActions";

import {
    SET_TERMS_ACCEPTED,
    SET_IMPERSONATED_CLIENT,
    SET_DOCUMENT_PREFERENCES,
    SET_DOCUMENT_DELIVERY_OPTIONS,
    SUCCESSFUL_LOGIN,
    SET_CURRENT_USER,
    SET_USER_PREFERENCES,
    SET_AD_HOC_FEE_AUTH,
    SET_REGISTRATION_USER,
    SET_RESET_PASSWORD,
    SET_USER_LOCATION_ID
} from "./clientPortalUserActions";

const defaultState = {
    id: null,
    termsAccepted: null,
    roles: [],
    username: "",
    lastLogin: null,
    isLoggedIn: false,
    preferences: { adHocFeeAuth: {}, correspondenceDelivery: {} }
};

export const user = (state = defaultState, action) => {
    switch (action.type) {
        case SUCCESSFUL_LOGIN: {
            const id = isAdviser(action.response.roles)
                ? {
                      adviserId: action.response.clientId,
                      id: action.response.impersonatedClient?.clientId ?? null
                  }
                : { id: action.response.clientId };

            const roles = isAdviser(action.response.roles)
                ? {
                      roles: action.response.impersonatedClient?.roles ?? [],
                      adviserRoles: action.response.roles
                  }
                : { roles: action.response.roles };

            const termsAccepted = isAdviser(action.response.roles)
                ? { termsAccepted: true }
                : { termsAccepted: action.response.termsAccepted };

            const username = isAdviser(action.response.roles)
                ? action.response.username
                : action.username;
            return {
                ...state,
                ...id,
                ...roles,
                ...termsAccepted,
                username,
                lastLogin: action.response.lastLogin,
                isLoggedIn: true
            };
        }

        case SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.client
            };

        case SET_TERMS_ACCEPTED:
            return {
                ...state,
                termsAccepted: true
            };

        case SET_IMPERSONATED_CLIENT: {
            return {
                ...state,
                id: action.client.clientId,
                roles: action.client.roles
            };
        }

        case SET_DOCUMENT_PREFERENCES: {
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    correspondenceDelivery: {
                        ...state.preferences?.correspondenceDelivery,
                        currentPreferences: action.documentPreferences
                    }
                }
            };
        }

        case SET_DOCUMENT_DELIVERY_OPTIONS: {
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    availableOptions: {
                        allDeliveryOptions: action.options
                    }
                }
            };
        }

        case SET_AD_HOC_FEE_AUTH: {
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    adHocFeeAuth: action.newStatus
                }
            };
        }

        case SET_USER_PREFERENCES: {
            return {
                ...state,
                preferences: { ...state.preferences, ...action.preferences }
            };
        }

        case SET_REGISTRATION_USER:
            return {
                ...state,
                registrationUser: action.username
            };

        case SET_RESET_PASSWORD:
            return {
                ...state,
                resetPassword: action.resetPassword
            };

        case SET_USER_LOCATION_ID:
            return {
                ...state,
                userLocationId: action.locationId
            };

        case HYDRATE_STATE:
            return { ...state, ...action.newState.user };

        default:
            return state;
    }
};
